import React from "react";
import { AuthProvider } from "./contexts/AuthContext/AuthContext";
import { ChatProvider } from "./contexts/ChatContext/ChatContext";
import { ConversationProvider } from "./contexts/ChatContext/ConversationContext";
import { InformationBasicProvider } from "./contexts/InformationBasicContext/InformationBasicContext"
import {ThreadProvider } from "./contexts/Thread/ThreadContext"
import AppRoutes from "./routes/routes";

function App() {
  return (
    <AuthProvider>
      <InformationBasicProvider>
        <ThreadProvider>
          <ConversationProvider>
            <ChatProvider>
                <AppRoutes />
            </ChatProvider>
          </ConversationProvider>
        </ThreadProvider>
      </InformationBasicProvider>
    </AuthProvider>
  );
}

export default App;
